<template>
  <slot :add="onAdd" />
  <div class="vstack gap-4 filestack">
    <template v-for="file in files" :key="file.key">
      <Upload
        v-slot="{ upfile }"
        :model-value="[file]"
        choose-on-mount
        :division="division"
        :url="url"
        @update:model-value="onUploaded"
        @upload:remove="onRemoved"
        @upload:cancel="onCanceled"
        @upload:done="$emit('upload:done', $event)"
      >
        <component :is="upfile" />
      </Upload>
    </template>
  </div>
</template>
<script setup>
import { computed, ref, toValue, watch } from 'vue'
import Upload from '@/components/upload/upload.vue'
import { isAfter } from 'date-fns'

const props = defineProps({
  division: String,
  url: String,
})
const model = defineModel({
  type: Array,
})
const emit = defineEmits(['upload:done'])
const uniqueModel = computed(() =>
  Object.values(
    (model.value || []).reduce((m, f) => {
      m[f.secure_filename] = f
      return m
    }, {})
  )
)
const files = ref([])

watch(
  model,
  mv => {
    if (!Array.isArray(mv)) {
      return
    }

    files.value = getValues(mv, props.division)
  },
  { immediate: true, deep: true }
)

function getValues(mv, div) {
  let fval = mv.filter(f => f.division == div)
  if (!fval.length) {
    return []
  }

  fval.sort((a, b) => (isAfter(a.uploaded_at, b.uploaded_at) ? 1 : -1))
  fval = fval.map(f => {
    return {
      ...f,
      key: f.secure_filename || '__NEW__',
    }
  })
  return fval
}

function onAdd() {
  files.value = [...files.value, {}]
}
function onUploaded(fls) {
  if (!fls?.length) {
    return
  }
  const f = fls.find(f => f.secure_filename)
  if (!f) {
    return
  }
  model.value = [...uniqueModel.value, toValue(f)]
}
function onRemoved(ex) {
  const m = uniqueModel.value
  const idx = m.findIndex(f => f.secure_filename == ex.secure_filename)
  if (idx === -1) {
    return
  }
  m.splice(idx, 1)
  model.value = m
  emit('upload:done')
}
function onCanceled() {
  files.value = files.value.filter(f => Object.keys(f).length > 0)
  emit('upload:done')
}
</script>
